import { useEffect, useRef, useState } from 'react';

export function useWindowResize(callback: (width: number) => void) {
    const requestRef = useRef<null | number>(null);
    const pending = useRef(false);
  
    useEffect(() => {
      const handleResize = () => {
        if (!pending.current) {
          pending.current = true;
          requestRef.current = requestAnimationFrame(() => {
            callback(window.innerWidth);
            pending.current = false;
          });
        }
      };
  
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
        if (requestRef.current) {
          cancelAnimationFrame(requestRef.current);
        }
      };
    }, [callback]);
  }